<template>

    <div fluid>
        <form>
          <p class="pt-2" v-if="!isDialog">Schedule details</p>
            <div class="form-row mb-3">
                <b-col cols="12" sm="12">
                  <v-select v-model="selectedTimeZone" :options="timeZones" placeholder="Time zone"></v-select>
                </b-col>
            </div>
            <template v-for="(deliveryDate, index) in deliveryDatesArr">
              <div class="form-row mb-3" :key="index">
                  <b-col cols="11" sm="11">
                    <datetime v-model="deliveryDates[index]" format="yyyy-MM-dd HH:mm" type="datetime"></datetime>
                  </b-col>
                  <b-col cols="1" class="mt-2" sm="1">
                    <b-link @click="addDeliveryDate" class="pull-right" v-if="index == 0">
                      <i class="icon-plus text-success"></i>
                    </b-link>
                    <b-link @click="removeDeliveryDate(index)" class="pull-right" v-else>
                      <i class="icon-close text-danger"></i>
                    </b-link>
                  </b-col>
              </div>
            </template>
            <template v-if="!isMultiTimes">
              <div class="form-row mb-3">
                  <b-col cols="12" sm="12">
                  <v-select v-model="selectedRecurrence" :options="recurrenceOptions" placeholder="Recurrence [Optional]"></v-select>
                  </b-col>
              </div>
              <template v-if="selectedRecurrence != null">
                <div class="aside-options pb-3">
                  <div class="clearfix mt-4">
                    <small><b>Stop date</b></small>
                    <c-switch class="float-right" color="primary" v-model="checkStopDate" checked label dataOn="on" dataOff="off"/>
                  </div>
                  <div>
                    <small class="text-muted">Turn off to run continuously.</small>
                  </div>
                </div>
                <div class="form-row mb-3" v-if="checkStopDate">
                  <b-col cols="12" sm="12">
                    <datetime v-model="stopDate" format="yyyy-MM-dd" type="date"></datetime>
                  </b-col>
                </div>
                <div class="form-row mb-3">
                  <b-col cols="12" sm="12">
                    <v-select v-model="selectedCollection" :options="getTemplateGroups" placeholder="Send from sms collection"></v-select>
                  </b-col>
                </div>
                <template v-if="selectedCollection != null">
                  <div class="aside-options pb-3">
                    <div class="clearfix mt-4">
                      <small><b>Send at random time?</b></small>
                      <c-switch class="float-right" color="primary" v-model="checkRandomTime" checked label dataOn="yes" dataOff="no"/>
                    </div>
                    <div>
                      <small class="text-muted">You can set time range that your message can randomly send at.</small>
                    </div>
                  </div>
                  <div class="form-row mb-3" v-if="checkRandomTime">
                      <b-col cols="3" sm="3">
                        <datetime v-model="fromTime" format="HH:mm" type="time"></datetime>
                      </b-col>
                      <b-col cols="1" sm="1">
                        to
                      </b-col>
                      <b-col cols="3" sm="3">
                        <datetime v-model="toTime" format="HH:mm" type="time"></datetime>
                      </b-col>
                  </div>
                  <div class="form-row mb-3" v-if="message.message.trim().length > 0">
                    <b-col cols="12" sm="12">
                      <v-select v-model="selectedsendAs" :options="sendAsOptions" placeholder="Use compose message as"></v-select>
                    </b-col>
                  </div>
                </template>
              </template>
            </template>
            <b-row>
                <b-col sm="12" class="ml-auto">

                  <b-button class="mr-1" type="button" @click="handleSchedule" variant="info">
                    <span v-if="!scheduling">{{scheduleActionText}}</span>
                      <div class="sk-circle" v-if="scheduling">
                          <div class="sk-circle1 sk-child"></div>
                          <div class="sk-circle2 sk-child"></div>
                          <div class="sk-circle3 sk-child"></div>
                          <div class="sk-circle4 sk-child"></div>
                          <div class="sk-circle5 sk-child"></div>
                          <div class="sk-circle6 sk-child"></div>
                          <div class="sk-circle7 sk-child"></div>
                          <div class="sk-circle8 sk-child"></div>
                          <div class="sk-circle9 sk-child"></div>
                          <div class="sk-circle10 sk-child"></div>
                          <div class="sk-circle11 sk-child"></div>
                          <div class="sk-circle12 sk-child"></div>
                      </div>
                      <i v-if="flashSendError" class="fa fa-times"></i>
                  </b-button>

                  <b-button class="mr-1" type="button" @click="cancelSchedule">Cancel</b-button>
                </b-col>
            </b-row>
        </form>
    </div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import { Datetime as datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import { Switch as cSwitch } from '@coreui/vue'
import { timeZones } from '@/constants'
import { mapGetters, mapActions, mapState } from "vuex"
import {} from '@/services/notification.service'

export default { 
  name: 'Schedule',
  components: {
    vSelect,
    cSwitch,
    datetime
  },
  data () {
    return {
        selectedTimeZone: null,
        timeZones: timeZones,
        selectedCollection: null,
        selectedRecurrence: null,
        selectedsendAs: null,
        deliveryDates: [Vue.moment().format()],
        stopDate: Vue.moment().format(),
        flashSaveError: false,
        fromTime: '',
        toTime: '',
        checkRandomTime: true,
        checkStopDate: true,
        isMultiTimes: false,
        isRecurrence: false,
        recurrenceOptions: this.prepareRecurrenceOptions(Vue.moment().format()),
        sendAsOptions: [{value: 1, label: 'Prefix (Heading)'}, {value: 2, label: 'Suffix (Signature)'}],
        scheduleActionText : 'Complete schedule',
        flashSendError: false
    }
  },
  notifications: {

    showScheduleSuccess: {
      title: 'Success',
      message: 'Your message has been sucessfully scheduled!',
      type: 'success'
    },
    showScheduleFailed: {
      title: 'Failed',
      message: 'Schedule could not be completed at this time!',
      type: 'error'
    },
    scheduleValidationError: {
      title: 'Error',
      message: 'incomplete schedule form was about to be sent!',
      type: 'error'
    }
  },
  props: {
    message: {
      type: Object,
      required: true,
      default: () => null
    },
    isDialog: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapState('smsCollection', ['templateGroups']),
    ...mapState('message', ['scheduling', 'serverResponse']),
    getTemplateGroups: function() {
        let templateGroups = []
        for (let index in this.templateGroups) {
          if (!this.templateGroups[index].approved || (this.templateGroups[index].personal && 
                                                          this.templateGroups[index].user_id != this.user.id))
            continue

          let templateGroup = { label: `${this.templateGroups[index].name} [${this.templateGroups[index].total_templates}]`, value: this.templateGroups[index].id }

          templateGroups.push(templateGroup)
        }
        return templateGroups
    },
    deliveryDatesArr(){
      return this.deliveryDates
    }
  },
  methods: {
    ...mapActions('message', [
      'schedule'
    ]),
    async handleSchedule() {
      if(this.scheduling)
        return
    
      let selectedCollectionId = 0
      if (this.selectedCollection != null) {
        selectedCollectionId = this.selectedCollection.value
      }

      if (this.selectedTimeZone == null) {
        this.scheduleValidationError({message:"Please select Timezone"})
        return
      }

      if(this.message != null || selectedCollectionId > 0) {
        let requestData = this.message
        let recurrenceId = 1
        if (this.selectedRecurrence != null) {
          recurrenceId = this.selectedRecurrence.value
        }

        let sendAsId = 1
        if (this.selectedsendAs != null) {
          sendAsId = this.selectedsendAs.value
        }

        if (this.deliveryDates.length == 1) {
          requestData.extras = [{
            "deliver_at": this.deliveryDates[0],
            "end_date": this.stopDate,

            "end_recurrence": this.checkStopDate,
            "recurrence_id": recurrenceId,
            "template_group_id": selectedCollectionId,

            "time_start_at": this.fromTime,
            "time_stop_at": this.toTime,

            "time_zone_id": this.selectedTimeZone.value,
            "use_composed_as": sendAsId
          }]
        } else {
          requestData.extras = []
          for (let i = 0; i < this.deliveryDates.length; i++) {
            requestData.extras.push({
              "deliver_at": this.deliveryDates[i],
              "end_date": this.stopDate,

              "end_recurrence": this.checkStopDate,
              "recurrence_id": recurrenceId,
              "template_group_id": 0,

              "time_start_at": this.fromTime,
              "time_stop_at": this.toTime,

              "time_zone_id": this.selectedTimeZone.value,
              "use_composed_as": sendAsId
            })
          } 
        }
        
        let status = await this.schedule({ data: requestData})
          
        if( !status ) {
          this.scheduleActionText = ''
          this.flashSendError = true
          this.showScheduleFailed({message: this.serverResponse.message})

          let interval = setInterval(() => {
            this.scheduleActionText = 'Complete schedule'
            this.flashSendError = false
            clearInterval(interval)
          }, 1000)

        } else {
          this.showScheduleSuccess()
          this.cancelSchedule()
        }
      } else {
        this.scheduleValidationError()
      }
    },
    addDeliveryDate: function() {
      this.deliveryDates = Vue.lodash.concat(this.deliveryDates, Vue.moment().format())
    },
    removeDeliveryDate: function(index) {
      let newDeliveryDates = this.deliveryDates
      Vue.lodash.pullAt(newDeliveryDates, index)
      this.deliveryDates = []
      this.deliveryDates = newDeliveryDates
    },
    prepareRecurrenceOptions: function(date) {
      let firstDeliveryDate = Vue.moment(date)
      let options = [
          {value: 1, label: 'Daily'},
          {value: 2, label: `Weekly (every ${firstDeliveryDate.format('dddd')})`},
          {value: 3, label: 'Weekly (every Monday - Friday)'},
          {value: 4, label: 'Weekly (every Sturday & Sunday)'},
          {value: 5, label: `Monthly (every first ${firstDeliveryDate.format('dddd')})`},
          {value: 6, label: `Monthly (every last ${firstDeliveryDate.format('dddd')})`},
          {value: 7, label: `Monthly (on day ${firstDeliveryDate.format('DD')})`},
          {value: 8, label: 'Monthly (last day of every Month)'},
          {value: 9, label: `Yearly (on ${firstDeliveryDate.format('MMMM')} ${firstDeliveryDate.format('DD')})`},
        ]

        return options
    },
    cancelSchedule: function() {
      this.$emit('cancel-schedule')
    }
  },
  watch: {
    deliveryDates(newValue, oldValue) {
      this.isMultiTimes = this.deliveryDates.length > 1 ? true : false
      if (!this.isMultiTimes) {
        this.recurrenceOptions = this.prepareRecurrenceOptions(this.deliveryDates[0])
      }
    },
    selectedRecurrence(newValue, oldValue) {
      if(newValue == null)
        this.isMultiTimes = this.deliveryDates.length > 1 ? true : false
    },
  },
}
</script>


<style scoped>
  .sk-circle{
    margin: 0 auto 1px auto;
    width: 20px;
    height: 20px;
    position: relative;
    color: white !important;
  }
</style>